import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import Label from "./Label";

import { isInvalidClass, validationClass, validationMode } from "../../config/helpers";
import SelectOptions, { ISelectValue } from "./SelectOptions";

interface IProps {
  label?: string;
  formName: string;
  nullValue?: string;
  ismandatory?: boolean;
  //selectedId?: number | string;
  popover?: string;
  options?: ISelectValue[];
  optionEmpty?: string;
  validationStyle?: validationMode;
  extraOnChange?: (val:any) => void;
  errors?: string;
  setValue?: any;
  getValue?: any;
  error?: string;
  disabled?: boolean;
  //defaultValue?: number|string|undefined;
}
const SelectInput: React.FC<IProps> = ({
  formName,
  label = formName,
  nullValue,
  ismandatory,
  //selectedId,
  popover,
  options,
  optionEmpty,
  validationStyle = validationMode.classic,
  extraOnChange,
  setValue,
  //defaultValue,
  error,
  disabled
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    register,
    control,
    getValues,
    getFieldState,
    watch,
    formState: { errors },
  } = useFormContext();


  if (options && optionEmpty) {
    options = [
      { Id: "", Libelle: optionEmpty }, // Option par défaut
      ...options ,
    ];
  }

  const watchedformName= watch(formName);

  const validationClassName = (): string => {
    const fieldValue = getValues(formName);
    const hasError = getFieldState(formName).error || error;
    
    // Considérer le champ comme valide uniquement s'il a une valeur réelle (pas vide, pas "DEFAULT")
    const hasValue = fieldValue !== undefined && 
                     fieldValue !== null && 
                     fieldValue !== "" && 
                     fieldValue !== "DEFAULT";
    
    switch (validationStyle) {
      case validationMode.classic:
        return validationClass(hasError, !hasError && hasValue);
      case validationMode.invalid:
        return isInvalidClass(errors || error);
      default:
        return "";
    }
  };

  return (
    <Label
      label={label}
      htmlFor={formName}
      errors={getFieldState(formName).error?.message || error}
      ismandatory={ismandatory}
      popover={popover}
    >
      <Controller
        name={formName}
        control={control}
        render={({ field }) => (
          <select
            disabled={disabled}
            id={formName}
            className={`form-select ${validationClassName()}`}
            {...register(formName)}
            autoComplete="off"
            onChange={(e) => {
              field.onChange(e);
              extraOnChange && extraOnChange(e);
              setValue && setValue(formName, e.target.value); // Mettez à jour la valeur du champ avec setValue
            }}
            defaultValue={watchedformName}
          >
            <SelectOptions
              options={options}
              nullValue={nullValue}
              
              //selectedId={selectedId}
            />
          </select>
        )}
      />
    </Label>
  );
};

export default SelectInput;
